// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"2135b662a421055207ab","453":"06a10aaf245804283298","603":"dca980ca9d9afa5b7f6b","739":"3dbcc8c0e0bf924ecc8f"}[chunkId] + ".js";
};